import React, { useState, useRef } from 'react';
import s from './VideoPlayer.module.scss';
import { VideoPlayIcon, VideoTriangleIcon } from '../../../assets/icons/job';

const VideoPlayer = ({ src, poster, title }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        setIsLoading(true);
        videoRef.current.play().catch(err => {
          console.error('Ошибка воспроизведения:', err);
          setIsLoading(false);
        });
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  const handleVideoClick = (e) => {
    e.stopPropagation();
    togglePlay();
  };

  const handlePlay = () => {
    setIsPlaying(true);
    setIsLoading(false);
    setError(null);
  };

  const handlePause = () => {
    setIsPlaying(false);
    setIsLoading(false);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    setIsLoading(false);
  };

  const handleLoadStart = () => {
    setIsLoading(true);
  };

  const handleCanPlay = () => {
    setIsLoading(false);
  };

  const handleWaiting = () => {
    setIsLoading(true);
  };

  const handlePlaying = () => {
    setIsLoading(false);
    setIsPlaying(true);
  };

  const handleError = () => {
    setError('Ошибка загрузки видео');
    setIsLoading(false);
  };
  // const handleError = (e) => {
  //   console.error('Video error details:', {
  //     error: videoRef.current.error,
  //     errorCode: videoRef.current.error?.code,
  //     errorMessage: videoRef.current.error?.message,
  //     networkState: videoRef.current.networkState,
  //     readyState: videoRef.current.readyState,
  //     src: src
  //   });
    
  //   let errorMessage = 'Ошибка загрузки видео';
    
  //   if (videoRef.current.error) {
  //     switch(videoRef.current.error.code) {
  //       case MediaError.MEDIA_ERR_ABORTED:
  //         errorMessage = 'Загрузка видео прервана';
  //         break;
  //       case MediaError.MEDIA_ERR_NETWORK:
  //         errorMessage = 'Ошибка сети при загрузке видео';
  //         break;
  //       case MediaError.MEDIA_ERR_DECODE:
  //         errorMessage = 'Ошибка декодирования видео';
  //         break;
  //       case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
  //         errorMessage = 'Формат видео не поддерживается';
  //         break;
  //       default:
  //         errorMessage = 'case default: Ошибка непонятного происхождения';
  //     }
  //   }
    
  //   setError(errorMessage);
  //   setIsLoading(false);
  // };


  // Определяем тип видео по расширению
  const getVideoType = (src) => {
    const srcLowerCase = src.toLowerCase();
    
    if (srcLowerCase.endsWith('.mov')) {
      return 'video/quicktime';
    } 
    if (srcLowerCase.endsWith('.mp4')) {
      return 'video/mp4';
    } 
    if (srcLowerCase.endsWith('.webm')) {
      return 'video/webm';
    }
    return 'video/mp4'; // fallback
  };


  return (
    <div className={s.videoWrapper} onClick={handleVideoClick}>
      <video 
        ref={videoRef}
        className={s.video}
        poster={poster}
        preload="metadata"
        onPlay={handlePlay}
        onPause={handlePause}
        onEnded={handleEnded}
        onLoadStart={handleLoadStart}
        onCanPlay={handleCanPlay}
        onWaiting={handleWaiting}
        onPlaying={handlePlaying}
        onError={handleError}
        onClick={handleVideoClick}
        playsInline // Важно для iOS
        webkit-playsinline="true" // Для Safari
      >
        <source src={src} type={getVideoType(src)} />
        {/* Дублируем в mp4 для браузеров, которые не поддерживают MOV */}
        {/* <source src={src.replace('.mov', '.mp4')} type="video/mp4" /> */}
        {/* Ваш браузер не поддерживает видео тег. */}
      </video>
      
      {/* Индикатор загрузки */}
      {isLoading && (
        <div className={s.loadingSpinner}>
          <div className={s.spinner}></div>
        </div>
      )}
      
      {/* Сообщение об ошибке */}
      {error && (
        <div className={s.errorMessage}>
          <span>{error}</span>
        </div>
      )}
      
      {/* Кастомная кнопка play/pause */}
      {!isPlaying && !isLoading && !error && (
        <button 
          className={s.playButton}
          onClick={handleVideoClick}
          aria-label={isPlaying ? "Пауза" : "Воспроизвести"}
        >
          <div className={s.fillCircle}>
            <VideoTriangleIcon />
          </div>
        </button>
      )}
      
    </div>
  );
}

export default VideoPlayer;